import React from "react";
import { Container, Row, Col } from "reactstrap";

const HeroArticle = ({ title, subtitle }) => {
    return (
        <section className="section section-lg hero-primary text-white">
            <Container>
                <Row className="justify-content-center text-center">
                    <Col lg="8">
                        <h1 className="display-3 font-weight-bold mb-3">
                            {title}
                        </h1>
                        {subtitle && (
                            <p className="lead">
                                {subtitle}
                            </p>
                        )}
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default HeroArticle;